import { render, staticRenderFns } from "./upgradeForm.vue?vue&type=template&id=68285550&"
import script from "./upgradeForm.vue?vue&type=script&lang=js&"
export * from "./upgradeForm.vue?vue&type=script&lang=js&"
import style0 from "./upgradeForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "upgradeForm.vue"
export default component.exports